export const loteTipo = {
	interno: 'Interno',
	externo: 'Externo',
};
